"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.show)
        ? (vue_1.openBlock(), vue_1.createElementBlock("div", {
            key: 0,
            class: "mask",
            onClick: _cache[0] || (_cache[0] = vue_1.withModifiers(
            //@ts-ignore
            function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (_ctx.toggleView && _ctx.toggleView.apply(_ctx, args));
            }, ["self"]))
        }, [
            vue_1.renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
        : vue_1.createCommentVNode("", true);
}
exports.render = render;
